import {useCallback, useEffect, useMemo, useRef, useState} from "react"
import {
    aplicarDefaultsPorDiferenca,
    aplicarTodosDefaults,
    calcularDefaults,
    criarContextoDefaults,
    obterTipoEmissao,
} from "../utils/parametros-defaults"

export const useParametrosDefaults = ({
                                          setFormData,
                                          jurosOptions,
                                          indexadoresIndicePrecoTR,
                                          indexadoresCarregados,
                                          grupoAtivosController,
                                      }) => {
    const grupoAtivosOptions = grupoAtivosController?.meta?.options
    const grupoAtivosPronto =
        !grupoAtivosController?.meta?.loading &&
        (!Array.isArray(grupoAtivosOptions) || grupoAtivosOptions.length > 0)

    const contexto = useMemo(
        () => criarContextoDefaults({
            indexadoresIndicePrecoTR,
            jurosOptions,
            getTipoEmissao: (tipoAtivo) => obterTipoEmissao(grupoAtivosOptions, tipoAtivo),
        }),
        [indexadoresIndicePrecoTR, jurosOptions, grupoAtivosOptions]
    )

    const contextoRef = useRef(contexto)
    contextoRef.current = contexto

    const [pendente, setPendente] = useState(false)
    const editadosRef = useRef(new Set())

    const aplicarDefaultsAlterados = useCallback(
        (prev, next) => aplicarDefaultsPorDiferenca(prev, next, contextoRef.current),
        []
    )

    const calcularDefaultsAtuais = useCallback(
        (state) => calcularDefaults(state, contextoRef.current),
        []
    )

    const solicitarDefaultsCompletos = useCallback(() => {
        editadosRef.current = new Set()
        setPendente(true)
    }, [])

    const registrarEdicao = useCallback((section, key) => {
        editadosRef.current.add(`${section}.${key}`)
    }, [])

    const contextoPronto =
        Array.isArray(jurosOptions) &&
        jurosOptions.length > 0 &&
        indexadoresCarregados &&
        grupoAtivosPronto

    useEffect(() => {
        if (!pendente || !contextoPronto) return

        const ignorar = new Set(editadosRef.current)
        setFormData((prev) => aplicarTodosDefaults(prev, contextoRef.current, ignorar))
        setPendente(false)
    }, [pendente, contextoPronto, setFormData])

    return {
        aplicarDefaultsAlterados,
        solicitarDefaultsCompletos,
        registrarEdicao,
        calcularDefaultsAtuais,
    }
}